module.exports = __webpack_public_path__ + "static/media/x-1.102d13f0.svg";